import { Injectable, ComponentFactoryResolver, Injector, ViewContainerRef, ComponentRef } from "@angular/core";
// migrated 1:1 from @nexato/nx-core-module (#682)
import { EntityRowRenderer } from "../../../services/entity-link/entity-row-renderer.service";
import { Issue } from "../../../entities/issue/issue";
import { IssueRowComponent } from "./issue-row.component";

@Injectable()
export class IssueRowRenderer extends EntityRowRenderer {
  
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector
  ) {
    super();
  }

  canRender(entityType: string): boolean {
    return entityType === 'Issue';
  }

  render(entity: any, container: ViewContainerRef, injector?: Injector): ComponentRef<any> {
    const factory = this.componentFactoryResolver.resolveComponentFactory(IssueRowComponent);
    const componentRef = container.createComponent(factory, undefined, injector ?? this.injector);
    
    // Set the input property using setInput for signal-based inputs
    componentRef.setInput('issue', new Issue(entity));
    // componentRef.setInput('showFilesButton', false);
    // componentRef.setInput('showCommentsButton', false);
    // componentRef.setInput('columns', [ 'dueDateTimePeriod', 'state']);
    
    return componentRef;
  }
}